import React from 'react';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

const BLANK = '\u00a0';

interface StatusMessageProps {
  message: string;
  wrap?: boolean;
}

export function StatusMessage(props: StatusMessageProps) {
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down('sm'));

  const { message, wrap = false } = props;
  const color = message.match(/WARN/)
    ? 'warning'
    : message.match(/ERR/)
      ? 'error'
      : 'info';

  return (
    <Box
      role="status"
      aria-live="polite"
      sx={{
        margin: '0px',
        marginTop: '0px',
        padding: '0px',
        width: '100%',
        alignItems: 'center',
        justifyContent: 'center',
        display: 'flex',
        minHeight: '24px',
        height: wrap ? undefined : '24px',
        zIndex: '2',
        position: wrap ? 'relative' : 'absolute',
      }}
      textAlign={'center'}
    >
      {(message !== BLANK && (
        <Chip
          sx={{
            width: '100%',
            fontSize: isSmall ? '.7em' : '.75em',
            fontWeight: 'bold',
            letterSpacing: '-0.25px',
            height: wrap ? 'auto' : '20px',
            minHeight: '20px',
            '& .MuiChip-label': {
              whiteSpace: wrap ? 'normal' : undefined,
              overflowWrap: wrap ? 'anywhere' : undefined,
              paddingTop: wrap ? '4px' : undefined,
              paddingBottom: wrap ? '4px' : undefined,
            },
            backgroundColor: 'lightgray',
            color: '#0b77c0',
          }}
          label={message}
        />
      )) || <Typography sx={{ fontSize: '8px' }}>{BLANK}</Typography>}
    </Box>
  );
}
